import type { TableColumnConfig } from '@pct-ng/feature-table-material';
import type { TranslateAbleText } from '@pct-ng/i18n';
import { ColoredCellComponent } from './colored-cell.component';

export type Mapping<T = any> = {
  mapping: MappingFn<T>;
};
export type MappingFn<T = any> = (fieldValue: T) => {
  value: TranslateAbleText;
  colorClass: string;
};

export function createColoredColumn<T, K>(
  id: string,
  field: keyof T,
  label: TranslateAbleText,
  mapping: MappingFn<K>,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id,
    field,
    label,
    cellContent: ColoredCellComponent,
    cellCustomContent: (): Mapping => ({
      mapping,
    }),
    sortable,
  };
}
